import type { APIRequestQueryParams, APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type Client = APIResponse<'/api/v4/clients'>[number];
export type ClientsQuery = APIRequestQueryParams<'/api/v4/clients'>;

export const fetchClients = (params: ClientsQuery) =>
  get<Client[]>('/v4/clients', { params });
